import React, { useEffect, useState } from "react";
import { biLogger } from "../../../../../bi";
import { Divider, Popover, Text, TextButton } from "wix-style-react";
import s from './other-countries.scss';
export var CountriesPopover = function (_a) {
    var popoverTitle = _a.popoverTitle, popoverElementTitle = _a.popoverElementTitle, countries = _a.countries, popoverFooter1 = _a.popoverFooter1, popoverFooter2 = _a.popoverFooter2, contactMail = _a.contactMail, appId = _a.appId, onSupportClick = _a.onSupportClick;
    var _b = useState(false), shown = _b[0], toogleTooltip = _b[1];
    // tslint:disable-next-line: react-hooks-nesting
    useEffect(function () {
        if (shown) {
            // tslint:disable-next-line: no-floating-promises
            biLogger.appMarketAppSupportedGeoSHover({ app_id: appId });
        }
    }, [shown]);
    return (React.createElement(Popover, { showArrow: true, animate: true, placement: "right", shown: shown, onMouseEnter: function () { return toogleTooltip(true); }, onMouseLeave: function () { return toogleTooltip(false); }, appendTo: "parent" },
        React.createElement(Popover.Element, null,
            React.createElement(TextButton, { as: "a" }, popoverElementTitle)),
        React.createElement(Popover.Content, null,
            React.createElement("div", { className: s.countryPopover },
                React.createElement(Text, { size: 'small', weight: 'bold', className: s.countryPopoverTitle }, popoverTitle),
                React.createElement("div", { className: s.countriesList, style: countries.length < 5 ? { flexDirection: 'column' } : {} }, countries.map(function (country) { return (
                // tslint:disable-next-line:jsx-key
                React.createElement(Text, { size: "small", weight: "thin", className: s.countryPopoverCountry, style: { display: 'inline-flex' } },
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement("span", null, "- \u00A0"),
                        React.createElement("span", { style: { flex: '1' } }, country)))); })),
                contactMail && (React.createElement(React.Fragment, null,
                    React.createElement(Divider, null),
                    React.createElement("div", { className: s.popoverFooter },
                        React.createElement(Text, { size: 'tiny', secondary: true }, popoverFooter1),
                        React.createElement(TextButton, { as: "a", size: 'tiny', onClick: function () {
                                onSupportClick();
                            } }, popoverFooter2))))))));
};
//# sourceMappingURL=countries-popover.js.map